import { Switch, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

const SwitchController = (props) => {
  const {
    loading,
    disabled,
    defaultValue,
    name,
    control,
    label,
    labelColor,
    ...others
  } = props;

  return (
    <div className="filter-widget">
      {loading && <p>cargando</p>}
      <label className="d-flex flex-column justify-items-center">
        <Typography variant="h6" style={{ color: labelColor }}>
          {label}
        </Typography>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <Switch
              {...others}
              disabled={disabled}
              onChange={(e) => field.onChange(e.target.checked)}
              checked={field.value}
            />
          )}
        />
      </label>
    </div>
  );
};

export default SwitchController;
